export default {
  maxLength (max) {
    return (rule, value, callback) => {
      if (value !== undefined && value !== null && value !== '') {
        if (value.length > max) {
          callback(new Error(`长度不能大于${max}`))
        }
      }
      callback()
    }
  }
}
